<template>
  <div class="anomaly-bands">
    <div class="band-card band-green">
      <div class="band-text">
        <div class="band-name black--text">{{ t("greenAreas") }}</div>
        <div class="band-desc grey--text">{{ t("greenAreasDesc") }}</div>
      </div>
      <div class="band-pct black--text">{{ fmt(bands.green) }}</div>
    </div>
    <div class="band-card band-yellow">
      <div class="band-text">
        <div class="band-name black--text">{{ t("yellowAreas") }}</div>
        <div class="band-desc grey--text">{{ t("yellowAreasDesc") }}</div>
      </div>
      <div class="band-pct black--text">{{ fmt(bands.yellow) }}</div>
    </div>
    <div class="band-card band-red">
      <div class="band-text">
        <div class="band-name black--text">{{ t("redAreas") }}</div>
        <div class="band-desc grey--text">{{ t("redAreasDesc") }}</div>
      </div>
      <div class="band-pct black--text">{{ fmt(bands.red) }}</div>
    </div>
  </div>
</template>

<script>
/**
 * The Green / Yellow / Red performance-band cards ("Report Details") for one
 * analyzed date of an Anomaly Detection report. `bands` = { green, yellow, red }
 * area-share percentages (0-100).
 */
export default {
  name: "AnomalyBands",
  props: {
    bands: {
      type: Object,
      default: () => ({ green: null, yellow: null, red: null }),
    },
    // Lay the three cards out in a row (detail) or stacked (comparison column).
    row: { type: Boolean, default: false },
    i18nPrefix: { type: String, default: "reports.anomalyDetection" },
  },
  methods: {
    t(key) {
      return this.$t(`${this.i18nPrefix}.${key}`);
    },
    fmt(v) {
      return v == null ? "-" : `${v}%`;
    },
  },
};
</script>

<style scoped>
.anomaly-bands {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
}
.band-card {
  flex-grow: 1;
  border: 1px solid #e8e8e8;
  border-left-width: 6px;
  border-radius: 6px;
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.band-text {
  padding-right: 12px;
}
.band-name {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
}
.band-desc {
  font-size: 12px;
  line-height: 1.35;
}
.band-pct {
  font-weight: bold;
  font-size: 22px;
  white-space: nowrap;
}
.band-green {
  border-left-color: #2e9c5a;
}
.band-yellow {
  border-left-color: #e6c700;
}
.band-red {
  border-left-color: #e53935;
}
</style>
